import {Component, OnInit} from '@angular/core';
// import {Router} from '@angular/router';

@Component({
    selector: 'acabim-admin-groups',
    templateUrl: './groups.component.html'
})
export class GroupsComponent implements OnInit {

    ngOnInit(): void { }

}
